/*
 * des-tab-bar.js — De Egaline Schuur mobile bottom tab bar (feature/des-header).
 * -----------------------------------------------------------------------------
 * Keeps the tab bar's cart trigger's aria-expanded in sync with the cart
 * drawer. Horizon's header-actions.js does this for the trigger INSIDE its own
 * <header-actions> component only; the tab-bar trigger lives outside it, so
 * without this sync assistive technology would keep announcing the tab as
 * collapsed while the drawer is open (Codex P2 on PR #23).
 *
 * Mirrors the same mechanism: listen for the bubbling DrawerOpenEvent /
 * DrawerCloseEvent from assets/theme-drawer.js ('theme-drawer:open' /
 * 'theme-drawer:close'), filter on the #cart-drawer target, and reflect the
 * drawer's [open] attribute. Namespaced, no globals leaked; harmless no-op on
 * pages without a drawer-toggle cart tab.
 */
(function () {
  "use strict";

  function sync() {
    var drawer = document.getElementById("cart-drawer");
    if (!drawer) return;
    var expanded = drawer.hasAttribute("open") ? "true" : "false";
    var triggers = document.querySelectorAll('.des-tab-bar [aria-controls="cart-drawer"]');
    for (var i = 0; i < triggers.length; i++) {
      triggers[i].setAttribute("aria-expanded", expanded);
    }
  }

  // Event names are defined by DrawerOpenEvent/DrawerCloseEvent in
  // assets/theme-drawer.js; both bubble to document with the drawer as target.
  function onDrawerStateChange(event) {
    var target = event.target;
    if (!target || target.id !== "cart-drawer") return;
    sync();
  }

  document.addEventListener("theme-drawer:open", onDrawerStateChange);
  document.addEventListener("theme-drawer:close", onDrawerStateChange);

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", sync);
  } else {
    sync();
  }

  // Re-sync after the theme editor re-renders the section.
  document.addEventListener("shopify:section:load", sync);
})();
